import Loader from "components/Loader";
import MainContentLeft from "components/main-components/MainContentLeft";
import MultipleListingItems from "components/MultipleListing/MultipleListingItems";
import MultipleListingPopupFail from "components/MultipleListing/MultipleListingPopupFail";
import MultipleListingPopupSuccess from "components/MultipleListing/MultipleListingPopupSuccess";
import PageLoader from "components/page-components/PageLoader";
import Pagination from "components/Pagination";
import PlaceholderBlock from "components/placeholder-blocks/PlaceholderBlock";
import { usePopup } from "hooks/usePopup";
import { useRefreshItems } from "hooks/useRefreshItems";
import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useOutletContext } from "react-router-dom";
import { setError } from "store/user";

export const MarketplaceContext = createContext();

const MarketPlaceCards = () => {
  const {
    items,
    filters,
    isFiltersLoading,
    isItemsLoading,
    offsetCount,
    setOffsetCount,
    paginationData,
    getOpenedClass,
  } = useOutletContext();

  const { search } = useLocation();
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectMode, setSelectMode] = useState(false);
  const dispatch = useDispatch();
  const { type } = useSelector((state) => state.popups);
  const setPopupHook = usePopup();
  const refreshItems = useRefreshItems();

  const closePopup = () => {
    setPopupHook('close');
    setSelectedItems([]);
    setSelectMode(false);
    refreshItems();
    dispatch(setError(null));
  }

  useEffect(() => {
    if (selectMode) {
      setSelectMode(false);
    }
  }, [search]);

  useEffect(() => {
    setSelectedItems([]);
    setSelectMode(false);
  }, [])

  if (!items.length && isFiltersLoading === true) {
    return <PageLoader />;
  }

  return (
    <MarketplaceContext.Provider
      value={{
        selectedItems,
        setSelectedItems,
        selectMode,
        setSelectMode,
      }}
    >
      <main className="main-content">
        <MainContentLeft
          getOpenedClass={getOpenedClass}
          filters={filters}
          setOffsetCount={setOffsetCount}
        />
        <div className="main-content__right">
          {isItemsLoading && !items.length ? (
            <Loader />
          ) : items.length ? (
            <>
              <MultipleListingItems items={items} />
              <Pagination
                offsetCount={offsetCount}
                setOffsetCount={setOffsetCount}
                paginationData={paginationData}
              />
            </>
          ) : (
            <PlaceholderBlock />
          )}
        </div>
      </main>

      {type === 'multiple-listing-success' && <MultipleListingPopupSuccess close={closePopup} selectedItems={selectedItems} />}
      {type === 'multiple-listing-fail' && <MultipleListingPopupFail close={closePopup} />}
    </MarketplaceContext.Provider>
  );
};

export default MarketPlaceCards;
